import { get, patch, post } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getItemsList({ commit }, { params } = {}) {
    return get(`booking/resources`, {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  getBookingResourcesStatuses({ commit }) {
    return get(`booking/filters/statuses/resources`).then(response => {
      commit('setBookingResourcesStatuses', response.data.data);

      return response;
    });
  },

  getBookingResourcesTypes({ commit }) {
    return get(`/booking/filters/types`).then(response => {
      commit('setBookingResourcesTypes', response.data.data);

      return response;
    });
  },

  getFilteredBuildingComplexes(_, params) {
    return get(`/booking/filters/building-complexes`, params);
  },

  getFilteredBuildings(_, params) {
    return get(`/booking/filters/buildings`, params);
  },

  getFilteredResources(_, params) {
    return get(`/booking/filters/titles`, params);
  },

  getLockProviders(_, params) {
    return get('/booking/lock-providers', params);
  },

  getBookingResource: (_, { resourceId }) => {
    return get(`/booking/resource/${resourceId}`);
  },

  storeBookingResource: (_, { resource }) => {
    return post(`/booking/resource`, resource);
  },

  updateBookingResource: (_, { resourceId, resource }) => {
    return patch(`/booking/resource/${resourceId}`, resource);
  },

  getAvailableSlots(_, { resourceId, params }) {
    return get(`booking/resource/${resourceId}/available-slots`, params);
  }
};
